import { useEffect, useState } from "react";

const TZ = "America/Chicago";
export const ct = (iso, withTime = true) => (iso ? `${new Date(iso).toLocaleString("en-US", { timeZone: TZ, month: "short", day: "numeric", year: "numeric", ...(withTime ? { hour: "numeric", minute: "2-digit" } : {}) })}${withTime ? " CT" : ""}` : "—");

export const CentralClock = ({ className = "" }) => {
  const [t, setT] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setT(new Date()), 30000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className={className} data-testid="central-clock">
      <p className="font-mono text-2xl font-bold">{t.toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit" })} <span className="text-sm font-medium opacity-80">CT</span></p>
      <p className="text-sm opacity-90">{t.toLocaleDateString("en-US", { timeZone: TZ, weekday: "long", month: "long", day: "numeric", year: "numeric" })}</p>
    </div>
  );
};

export const greeting = () => {
  const h = Number(new Date().toLocaleString("en-US", { timeZone: TZ, hour: "numeric", hour12: false }));
  return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening";
};
